import { ImageLoaderProps } from 'next/dist/client/image';

export const prismicImgixLoader = (props: ImageLoaderProps) => {
  return `${props.src}&w=${props.width}&q=${props.quality}`;
};
